import useLenis from "../hooks/useLenis";
import { Navbar } from "../components/campaign/Navbar";
import { Hero } from "../components/campaign/Hero";
import { Marquee } from "../components/campaign/Marquee";
import { About } from "../components/campaign/About";
import { WhyRunning } from "../components/campaign/WhyRunning";
import { Priorities } from "../components/campaign/Priorities";
import { WhyNoman } from "../components/campaign/WhyNoman";
import { CampaignMessage } from "../components/campaign/CampaignMessage";
import { Endorsements } from "../components/campaign/Endorsements";
import { Donate } from "../components/campaign/Donate";
import { VoterCheck } from "../components/campaign/VoterCheck";
import { GetInvolved } from "../components/campaign/GetInvolved";
import { Contact } from "../components/campaign/Contact";
import { Footer } from "../components/campaign/Footer";

export default function Home() {
  useLenis();
  return (
    <div className="grain relative bg-white" data-testid="home-page">
      <Navbar />
      <main>
        <Hero />
        <Marquee />
        <About />
        <WhyRunning />
        <Priorities />
        <WhyNoman />
        <CampaignMessage />
        <Endorsements />
        <Donate />
        <VoterCheck />
        <GetInvolved />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}
